import { hybridSizingCategoriesMap } from "./size-selector-equivalencies";
import { WAIST_CATEGORIES } from "./constants";

export const isHybridSizing = (category = "", displayName = "") => {
  if (displayName.toLowerCase().includes("contour fit")) {
    return false;
  }
  return Object.keys(hybridSizingCategoriesMap).includes(category);
};

export const getEquivalencyText = (category, size) => {
  const equivalency = hybridSizingCategoriesMap?.[category]?.[size];

  if (!equivalency) {
    return "";
  }

  const article = /^(1[18]|[8xslm])/i.test(equivalency) ? "an" : "a";
  const isNumericSize = /^\d+$/.test(size);

  if (WAIST_CATEGORIES.includes(category)) {
    if (isNumericSize) {
      return `waist fits like ${article} ${equivalency}`;
    }

    return `fits like ${article} ${equivalency} waist`;
  }

  return `fits like ${article} ${equivalency}`;
};
